import { ReactElement } from 'react';
import { IClientCredential } from 'core/clientCredentialsApiService';

// Components
import Button from 'components/Button/Button';

// Styles
import styles from 'components/LearnerSearchTable/learnersearchtable.module.scss';

// Core + Store
import { ButtonVariant } from 'core/enums';

// Types
interface IProps {
  onDelete: (id: string) => void;
  onRotate: (clientId: string) => void;
  results: IClientCredential[];
}

export const BoardListTable = ({ results, onDelete, onRotate }: IProps): ReactElement => {
  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00Z`;
  };

  const isExpired = (expiresAt: string) => {
    if (!expiresAt) return false;
    return new Date(expiresAt) < new Date();
  };

  return (
    <div className={styles['learner-search-container']}>
      <table className={styles['learner-search-table']}>
        <thead className={styles['learner-search-table-thead']}>
          <tr>
            <th>Organization</th>
            <th>Client ID</th>
            <th>Issued At</th>
            <th>Expires At</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {results?.map((item: IClientCredential): ReactElement => {
            const { clientID, expiresAt, id, isDeleted, issuedAt, organizationName } = item;

            const expired = isExpired(expiresAt);

            return (
              <tr key={id}>
                <td>{organizationName}</td>
                <td style={{ fontFamily: 'monospace', fontSize: '12px' }} title={clientID}>
                  {clientID}
                </td>
                <td>{formatDate(issuedAt)}</td>
                <td style={{ color: expired ? 'red' : 'inherit' }}>
                  {formatDate(expiresAt)}
                  {expired && ' (Expired)'}
                </td>
                <td
                  style={{
                    color: isDeleted ? 'red' : expired ? 'orange' : 'green',
                    fontWeight: 'bold',
                  }}
                >
                  {isDeleted ? 'Deleted' : expired ? 'Expired' : 'Active'}
                </td>
                <td style={{ width: '280px' }}>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    {!isDeleted && !expired && (
                      <Button
                        onClick={() => onRotate(clientID)}
                        size="small"
                        title="Rotate Client Secret"
                        variant={ButtonVariant.Secondary}
                        style={{ padding: '4px 8px', fontSize: '12px' }}
                      >
                        Rotate
                      </Button>
                    )}
                    {!isDeleted && (
                      <Button
                        className="primary"
                        onClick={() => onDelete(id)}
                        size="small"
                        title="Delete Client Credential"
                        style={{ padding: '4px 8px', fontSize: '12px', minWidth: '6.25rem' }}
                      >
                        Delete
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
